export default "__VITE_ASSET__A3yljvk1__"